<template>
  <div>
    <div class="tan-cont">
      <div class="tan-cont-top">交出清单：</div>
      <ul class="tan-ul">
        <li>全部机构<h3>23个</h3>
        </li>
        <li>全部客户<h3>23个</h3>
        </li>
        <li>成交合同<h3>23个</h3>
        </li>
      </ul>
      <div class="tan-cont-bottom">
        选择接收人：
        <div class="tan-flex">
          <Table class="tan-table" stripe :columns="tancolumns" :data="tandata"></Table>
          <div class="tan-clear"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'people',
  data () {
    return {
      tancolumns: [{
        title: '交出清单',
        align: 'center',
        key: 'name',
        ellipsis: true
      }, {
        title: '接收人姓名',
        align: 'center',
        key: 'userName',
        ellipsis: true
      }],
      tandata: []
    }
  }
}
</script>
<style  lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";
.tan-cont {
  font-family: SimHei;
  max-height: 450px;
  overflow: hidden;
  overflow-y: scroll;
  font-size: 13px;
  padding-right: 5px;
  .tan-data {
    padding-top: 15px;
    .tan-data-btn {
      float: right;
    }
  }
  .tan-cont-top {
    width: 100%;
    margin-bottom: 15px;
    span {
      float: right;
    }
    .tan-Checkbox {
      margin-right: 10px;
    }
  }
  .tan-ul {
    display: block;
    width: 100%;
    height: 70px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    li {
      display: block;
      width: 130px;
      height: 55px;
      border: 1px dashed #53cac3;
      border-radius: 5px;
      text-align: center;
      padding-top: 5px;
      line-height: 20px;
    }
    li:last-child {
      margin-right: 0;
    }
  }
  .tan-cont-bottom {
    width: 100%;
    padding-left: 15px;
    padding-bottom: 20px;
    .tan-search {
      width: 100%;
      margin-top: 15px;
    }
    .tan-flex {
      width: 100%;
      margin-bottom: 20px;
      padding-top: 15px;

      .tan-clear {
        clear: both;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tan/people.vue